module.exports = __webpack_public_path__ + "img/exam-result-draft.2ddf7d7a.svg";